import React from 'react'

export const FuseLogo = (props: React.ComponentProps<'svg'>) => (
  <svg data-slot="icon" width="120" height="120" viewBox="0 0 120 120" fill="none" {...props}>
    <rect width="120" height="120" rx="30" fill="#F8632C" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.025 36.7434C35.025 32.7295 38.131 29.4756 41.9625 29.4756H78.0375C81.869 29.4756 84.975 32.7295 84.975 36.7434V55.6399H98.85C100.383 55.6399 101.625 56.8823 101.625 58.4149V61.5863C101.625 63.1189 100.383 64.3613 98.85 64.3613H84.975V83.2577C84.975 87.2716 81.869 90.5256 78.0375 90.5256H41.9625C38.131 90.5256 35.025 87.2716 35.025 83.2577V64.3613H21.15C19.6174 64.3613 18.375 63.1189 18.375 61.5863V58.4149C18.375 56.8823 19.6174 55.6399 21.15 55.6399H35.025V36.7434ZM43.35 64.3613V81.8042H76.65V64.3613H43.35ZM76.65 55.6399V38.197H43.35V55.6399H76.65Z"
      fill="white"
    />
  </svg>
)
